import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  .bp-nav,
  footer {
    display: none !important;
  }
`

export const EnquiryPageWrapper = styled.div`
  min-height: 100vh;
  padding: 2rem 0;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  font-size: 1.2rem;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  text-align: center;

  h1 {
    margin-bottom: 1rem;
  }

  p {
    color: #666;
  }
`
